import { create } from 'zustand';
import type { Calibration, ControlPoint } from '../geo/types';

/**
 * Draft calibration while an admin is aligning a base layer. The map shows the draft live;
 * nothing is saved until "Save calibration".
 */
interface CalibrationDraft {
  layerId: string | null;
  draft: Calibration | null;
  points: ControlPoint[];
  set: (patch: Partial<Omit<CalibrationDraft, 'set'>>) => void;
}

export const useCalibration = create<CalibrationDraft>((set) => ({
  layerId: null,
  draft: null,
  points: [],
  set: (patch) => set(patch),
}));
